import "./tabsStyles.css";
import { Col, Row } from "react-bootstrap";
import { useEffect, useState } from "react";
import Moment from "react-moment";

export default function HourlyTab({ data }: any) {
  const [ok, setOk] = useState(false);

  useEffect(() => {
    if (data !== undefined || data !== null) {
      setOk(true);
    }
  }, [data]);

  return (
    <div className="make-visible">
      <h2> Hourly Forecast </h2>
      {ok ? (
        <div>
          {data.hourly.map((item: any, index: number) => {
            let icon_path = `http://openweathermap.org/img/w/${item.weather[0].icon}.png`;
            return (
              <div className="clean-box" key={`hourly-${index}`}>
                <Row>
                  <Col xs={3}>
                    {" "}
                    <img className="minor-icons" src={icon_path} />{" "}
                  </Col>
                  <Col xs={5}>
                    {" "}
                    <Moment unix>{item.dt}</Moment>{" "}
                  </Col>
                  <Col style={{ fontWeight: "bolder" }}>{item.temp} °C</Col>
                </Row>

                <Row xs={2} md={4}>
                  <Col>Wind : </Col> <Col> {item.wind_speed} m/sec </Col>
                  <Col xs={7}>Wind Direction : </Col>{" "}
                  <Col xs={1}> {item.wind_deg}° </Col>
                  <Col>Humidity : </Col>{" "}
                  <Col> {Math.round(item.humidity * 100)}% </Col>
                  <Col>UV Index : </Col> <Col> {item.uvi} out of 10 </Col>
                  <Col>Clouds : </Col>{" "}
                  <Col> {Math.round(item.clouds * 100)}% </Col>
                  <Col>Feels Like : </Col> <Col> {item.feels_like} °C </Col>
                </Row>
              </div>
            );
          })}
        </div>
      ) : (
        <div>Loding...</div>
      )}
    </div>
  );
}
